module.exports = __webpack_public_path__ + "img/loreto-snorkel.c78ddd7b.jpg";